module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "toc-heading"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-foreword has-no-leading-number has-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/forewordmysticrhythms"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Foreword: Mystic Rhythms")])])]), _vm._v(" "), _c('p', {
    staticClass: "item-author"
  }, [_vm._v("Kevin J. Anderson")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-bodymatter toc-item-element-container-single toc-item-element-type-chapter has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/drumbeats",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Drumbeats")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-afterword has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/afterwordstoriesthatfiredmyimagination"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Afterword: Stories That Fired My Imagination")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheauthors"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Authors")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-about-author has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheartist"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("About the Artist")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/ifyouliked"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("If You Liked …")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-element-non-bodymatter toc-item-element-container-single toc-item-element-type-also-by has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/otherwordfirepresstitlesbykevinjanderson"
    }
  }, [_c('span', {
    staticClass: "item-title-text"
  }, [_vm._v("Other WordFire Press Titles by Kevin J. Anderson")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0